// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"15b1632a","20":"ed0c6518","63":"2353539f","470":"70cf35e4","670":"15e34150","679":"b73e27d8","866":"beb92c90","880":"faab5a73"}[chunkId] + ".css";
};